// getIndexOf filter
export default function getIndexOfFilter() {
	return function(
		propertyName,
		nestedPropertyName,
		propertyValue,
		collection
	  ) {
		if (!collection) return null;
  
		var i = 0,
		  len = collection.length;
		for (; i < len; i++) {
		  if (nestedPropertyName) {
			if (
			  collection[i][propertyName][nestedPropertyName] === propertyValue
			) {
			  return i;
			}
		  } else {
			if (collection[i][propertyName] === propertyValue) {
			  return i;
			}
		  }
		}
		return null;
	  };
}